// extracted by mini-css-extract-plugin
module.exports = {"main":"constructor-element_main__29fJ6","optional":"constructor-element_optional__1_AW3"};